import { render, staticRenderFns } from "./GroupOrders.vue?vue&type=template&id=3524d0ac&scoped=true&"
import script from "./GroupOrders.vue?vue&type=script&lang=js&"
export * from "./GroupOrders.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrders.vue?vue&type=style&index=0&id=3524d0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524d0ac",
  null
  
)

export default component.exports